import React from 'react';
import Section from '../ui/Section';
import { ArrowRight, Calendar, MapPin } from 'lucide-react';
import Button from '../ui/Button';

const conferences = [
  {
    id: 1,
    name: "ICAI Innovation Center Conference",
    talk: "From Code to Career: Women Shaping AI",
    date: "June 17, 2025",
    location: "CIC Rotterdam, Netherlands",
    description: "ICAI – Innovation Center for Artificial Intelligence and AI4ALL Women are teaming up for an evening of connection, insights, and inspiration at CIC Rotterdam.",
    link: "https://www.icai.ai/event/women-in-ai-event-icai-ai4all-women",
    image: "/image copy.png"
  },
  {
    id: 2,
    name: "Tech Show Frankfurt",
    talk: "The AI-Augmented Tech Landscape: Why Going Wide is the New Going Deep",
    date: "June 4, 2025",
    location: "Frankfurt, Germany",
    description: "As AI rapidly reshapes the tech industry, both individuals and organisations are facing a new reality: depth alone is no longer enough. In this talk, we'll explore how the rise of AI agents, copilots, and autonomous systems is changing the definition of value in tech roles and why adaptability, cross-functionality, and AI fluency are becoming the new competitive edge. We'll look at the shift from deep specialisation to broad, AI-augmented skillsets, and what that means for employees navigating their careers. On the business side, we'll examine how AI is pressuring companies to rethink organisational structures, product strategies, and decision-making processes.",
    link: "https://www.techshowfrankfurt.de/speakers/diana-almeida?&azletter=D&searchgroup=libraryentry-speakers",
    image: "/image copy copy.png"
  },
  {
    id: 3,
    name: "European Women in Technology",
    talk: "Reimagining Customer Experience with Generative AI",
    date: "June 25-26, 2025",
    location: "RAI, Amsterdam",
    description: "Interactive workshop on solving real customer experience challenges using generative AI technologies.",
    link: "https://www.europeanwomenintech.com/agenda-1/workshop-delivered-bookingcom-mvgm",
    image: "/image copy copy copy.png"
  }
];

const FindMeAt: React.FC = () => {
  return (
    <Section className="bg-neutral-900/50">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Speaking Engagements</h2>
        <p className="text-lg text-neutral-300 max-w-2xl mx-auto">
          Join us at these upcoming events where we'll be sharing insights on AI product development and Generative AI.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        {/* Featured Conference */}
        <div className="card card-hover p-6 lg:col-span-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative aspect-video rounded-lg overflow-hidden">
              <img 
                src={conferences[0].image}
                alt={conferences[0].name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col">
              <div className="flex items-start space-x-3 mb-4">
                <Calendar className="text-primary flex-shrink-0" />
                <div>
                  <p className="font-medium">{conferences[0].date}</p>
                  <div className="flex items-center mt-1 text-sm text-neutral-300">
                    <MapPin size={14} className="mr-1" />
                    {conferences[0].location}
                  </div>
                </div>
              </div>
              
              <h3 className="text-2xl font-semibold mb-2">{conferences[0].name}</h3>
              <p className="text-xl text-primary mb-3">{conferences[0].talk}</p>
              <p className="text-neutral-300 mb-4 flex-grow">{conferences[0].description}</p>
              
              <a 
                href={conferences[0].link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary flex items-center font-medium hover:underline group"
              >
                Event Details
                <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>

        {/* Other Conferences */}
        {conferences.slice(1).map((conference) => (
          <div key={conference.id} className="card card-hover p-6 flex flex-col">
            <div className="relative aspect-video rounded-lg overflow-hidden mb-4">
              <img 
                src={conference.image}
                alt={conference.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex items-start space-x-3 mb-4">
              <Calendar className="text-primary flex-shrink-0" />
              <div>
                <p className="font-medium">{conference.date}</p>
                <div className="flex items-center mt-1 text-sm text-neutral-300">
                  <MapPin size={14} className="mr-1" />
                  {conference.location}
                </div>
              </div>
            </div>
            
            <h3 className="text-xl font-semibold mb-2">{conference.name}</h3>
            <p className="text-lg text-primary mb-3">{conference.talk}</p>
            <p className="text-neutral-300 mb-4 flex-grow">{conference.description}</p>
            
            <a 
              href={conference.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary flex items-center font-medium hover:underline group"
            >
              Event Details
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        ))}
      </div>

      <div className="text-center">
        <a 
          href="https://calendly.com/productleapai/30min"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="secondary" className="group">
            Book us to speak at your conference
            <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </a>
      </div>
    </Section>
  );
};

export default FindMeAt;